(function($){

	/* ******************************************************************************
	------------------------------ Hover Parent Effect ------------------------------
	****************************************************************************** */
	$(document).on("mouseenter", ".hover-double-parent-js a", function(){
		$(this).parent().parent().addClass('hover-parent-active');
	});

	$(document).on("mouseleave", ".hover-double-parent-js a", function(){
		$(this).parent().parent().removeClass('hover-parent-active');
	});

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/hover-parent.js